import { TrendingUp, TrendingDown } from "lucide-react";

export default function KPICard({ title, value, suffix, hint, icon: Icon, trend, accent, testId }) {
    return (
        <div className="zentra-card p-5 flex flex-col gap-3" data-testid={testId}>
            <div className="flex items-center justify-between">
                <span className="text-[11px] font-semibold tracking-widest uppercase text-zentra-muted">{title}</span>
                {Icon && (
                    <div
                        className="w-8 h-8 rounded-md flex items-center justify-center"
                        style={{
                            background: accent ? "rgba(35,196,131,0.12)" : "rgba(24,57,43,0.06)",
                            color: accent ? "#16A36C" : "#18392B",
                        }}
                    >
                        <Icon size={16} strokeWidth={2} />
                    </div>
                )}
            </div>
            <div className="flex items-baseline gap-2">
                <span className="zentra-kpi-value" data-testid={`${testId}-value`}>
                    {value}
                </span>
                {suffix && <span className="text-sm font-medium text-zentra-muted">{suffix}</span>}
            </div>
            {hint && (
                <div className="flex items-center gap-2 text-xs text-zentra-muted">
                    {trend === "up" && <TrendingUp size={12} className="text-emerald-600" />}
                    {trend === "down" && <TrendingDown size={12} className="text-red-600" />}
                    <span>{hint}</span>
                </div>
            )}
        </div>
    );
}
